module.exports = __webpack_public_path__ + "img/cs-protrain-5.bb60f79e.jpg";